document.addEventListener('DOMContentLoaded', function () {
  // Selecciona todos los elementos <details> dentro de .accordion
  const accordions = document.querySelectorAll('.accordion details');

  // Itera sobre cada elemento <details>
  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
      // Si este acordeón está abierto, cierra los demás
      if (this.open) {
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== this) {
            otherAccordion.open = false; // Cierra los otros acordeones
          }
        });
      }
    });
  });
});
